import { render, staticRenderFns } from "./ArticleImage.vue?vue&type=template&id=b7450562&scoped=true"
import script from "./ArticleImage.vue?vue&type=script&lang=js"
export * from "./ArticleImage.vue?vue&type=script&lang=js"
import style0 from "./ArticleImage.vue?vue&type=style&index=0&id=b7450562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7450562",
  null
  
)

export default component.exports